import React from 'react';
import './PaymentSection.css'; // We’ll style the badge here

const PaymentSection = ({user}) => {
  const currentUrl = window.location.href;
  const successUrl = `${currentUrl}?payment=success`;

  const stripePaymentUrl = `https://buy.stripe.com/bIY29k4emh2pcaQ4gu?prefilled_email=${encodeURIComponent(
    user.email
  )}&client_reference_id=${user.id}&?success_url=${encodeURIComponent(successUrl)}`;

  return (
    <div className="payment-section">
      <div className="payment-container">
        {/* ← New “Best Offer” badge */}
        <div className="best-offer-badge">Best Offer</div>

        <h2>Schedule Your Consultation</h2>
        <p>Get personalized guidance from our expert consultants</p>
        
        <div className="payment-details">
          <div className="price-info">
            <span className="price">$25</span>
            <span className="per-text">Per Appointment</span>
          </div>
          
          <div className="payment-description">
            <p>
              Book a one-on-one consultation to discuss your admissions strategy, 
              application process, and receive personalized advice.
            </p>
          </div>
          
          <a 
            href={stripePaymentUrl}
            target="_blank" 
            rel="noopener noreferrer" 
            className="payment-button"
          >
            Make Payment
          </a>
        </div>
      </div>
    </div>
  );
};

export default PaymentSection;
